module.exports = __webpack_public_path__ + "img/toy.48131649.png";